'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var catalogItemsSortOrders = {
    /*eslint-disable */
    PRICE_HIGHEST_FIRST: 'PRICE_HIGHEST_FIRST',
    PRICE_LOWEST_FIRST: 'PRICE_LOWEST_FIRST',
    ESTIMATE_HIGHEST_FIRST: 'ESTIMATE_HIGHEST_FIRST',
    ESTIMATE_LOWEST_FIRST: 'ESTIMATE_LOWEST_FIRST',
    MOST_BIDS: 'MOST_BIDS',
    LEAST_BIDS: 'LEAST_BIDS',
    LOT_NUMBER_HIGHEST_FIRST: 'LOT_NUMBER_HIGHEST_FIRST',
    LOT_NUMBER_LOWEST_FIRST: 'LOT_NUMBER_LOWEST_FIRST'
    /*eslint-enable */
};

exports.default = catalogItemsSortOrders;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/enums/catalogItemsSortOrders.js
// module id = XnP6
// module chunks = 46